<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 55px; top: 55px;">
      <p>Escribe el nombre de cada animal en el cuadro que corresponde.</p>
    </span>

    <p class="textBase basicItem01 tagDefault" style="width:170px; left:30px; top:100px">GRILLO</p>
    <p class="textBase basicItem01 tagDefault alt" style="width:180px; left:280px; top:110px">ZORRO</p>
    <p class="textBase basicItem01 tagDefault" style="width:130px; left:530px; top:100px">PERRO</p>
    <p class="textBase basicItem01 tagDefault alt" style="width:130px; left:740px; top:110px">PATO</p>
    <p class="textBase basicItem01 tagDefault alt" style="width:170px; left:50px; top:210px">MOSCA</p>
    <p class="textBase basicItem01 tagDefault" style="width:170px; left:260px; top:200px">BAGRE</p>
    <p class="textBase basicItem01 tagDefault alt" style="width:210px; left:520px; top:200px">CARDENAL</p>
    <p class="textBase basicItem01 tagDefault" style="width:210px; left:780px; top:210px">PEJERREY</p>

    <div class="textBubble alt" style="width:380px; height: 80px; left: 10px; top: 310px;">
      <div class="textContainer textBase center" style="width: 90%; height: 90%;">
          <p class="center" style="font-size: 30px">¡Con plumas!</p>
      </div>
      <img class="arrow left" src="/pages/img/general/textBubbleArrow2.svg" style="top: 50px; left:200px;"/>
    </div>

    <img
    style="width: 200px; top: 400px; left: 40px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p28/zorrito.svg"
    />
    <div class="hover-animation-a" style="position:absolute; width:280px; height: 320px; top: 410px; left: 180px">
      <p class="textBase centerH" style="top: 42px; font-size:38px; position: absolute; color:white">Aves</p>
      <img style="width: 100%;"
      class="pageElement"
      src="/pages/img/sordovio/assets_p28/cartel.svg"/>
    </div>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="0"
      class="pageElement"
      style="
      z-index: 7; 
      width: 329px;
      left: 94px;
      top: 540px;
      height: 46px;"
      defaultText="PATO"
      disabled
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
      style="z-index: 7"
    />


    <div class="textBubble alt" style="width:500px; height: 80px; left: 570px; top: 310px;">
      <div class="textContainer textBase center" style="width: 90%; height: 90%;">
          <p class="center" style="font-size: 30px">¡Sin patas, ni plumas, ni pelos!</p>
      </div>
      <img class="arrow" src="/pages/img/general/textBubbleArrow2.svg" style="top: 50px; left:200px;"/>
    </div>

    <img
    style="width: 200px; top: 400px; left: 780px"
    class="pageElement flip"
    src="/pages/img/sordovio/assets_p28/zorrito.svg"
    />

    <div class="hover-animation-a" style="position:absolute; width:280px; height: 320px; top: 410px; left: 560px; z-index: -1;">
      <p class="textBase centerH" style="top: 42px; font-size:38px; position: absolute; color:white">Peces</p>
      <img style="width: 100%;"
      class="pageElement flip"
      src="/pages/img/sordovio/assets_p28/cartel.svg"/>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="pageElement"
      style="z-index: 7"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
      class="pageElement"
      style="z-index: 7"
    />
  </div>
</template>
<style scoped>
#inputField01 {
  position: absolute;
  width: 329px;
  left: 94px;
  top: 627px;
  height: 46px;
  font-size: 32px;
}
#inputField02 {
  position: absolute;
  width: 329px;
  height: 46px;
  left: 585px;
  top: 540px;

  font-size: 32px;
}
#inputField03 {
  position: absolute;
  width: 329px;
  height: 46px;
  left: 586px;
  top: 627px;
  font-size: 32px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "vio/Video 91_1.mp4",
        "vio/Video 92 ok.mp4",
        "vio/Video 95b.mp4",
        "vio/Video 96b.mp4",
      ],
    };
  },
};
</script>